import styles from "../../styles/applicationDetail.module.css";
import { GovernmentIdAttachmentPreview } from "./GovernmentIdAttachmentPreview";
import type { ApplicationLayerData } from "../../types/application";

type GovernmentIdDocumentsSectionProps = {
  applicationData: ApplicationLayerData;
  applicantId: string;
  testIdPrefix?: string;
};

function hasManualGovernmentIdUpload(
  applicationData: ApplicationLayerData,
): boolean {
  return Boolean(
    applicationData.goverment_id_attachment?.filepath?.trim() ||
      applicationData.goverment_id_attachment_back?.filepath?.trim(),
  );
}

export function hasGovernmentIdDocuments(
  applicationData: ApplicationLayerData,
): boolean {
  return hasManualGovernmentIdUpload(applicationData);
}

export function GovernmentIdDocumentsSection({
  applicationData,
  applicantId,
  testIdPrefix = "application-about-tab",
}: GovernmentIdDocumentsSectionProps) {
  if (!hasManualGovernmentIdUpload(applicationData)) {
    return null;
  }

  const previewGroup = [
    applicationData.goverment_id_attachment?.filepath
      ? {
          attachment: applicationData.goverment_id_attachment,
          fileType: "ID_PROOF" as const,
        }
      : null,
    applicationData.goverment_id_type === "Drivers License" &&
    applicationData.goverment_id_attachment_back?.filepath
      ? {
          attachment: applicationData.goverment_id_attachment_back,
          fileType: "ID_PROOF_BACK" as const,
        }
      : null,
  ].filter(
    (
      item,
    ): item is {
      attachment: NonNullable<ApplicationLayerData["goverment_id_attachment"]>;
      fileType: "ID_PROOF" | "ID_PROOF_BACK";
    } => item != null,
  );

  return (
    <div
      className={styles.governmentIdDocumentsBlock}
      data-testid={`${testIdPrefix}-section-government-id-documents`}
    >
      {applicationData.goverment_id_type ? (
        <>
          <h6 style={{ fontWeight: 700, marginBottom: "10px" }}>Goverment ID</h6>
          <p>{applicationData.goverment_id_type}</p>
        </>
      ) : null}
      <div className={styles.governmentIdAttachmentStack}>
        {applicationData.goverment_id_attachment?.filepath && (
          <GovernmentIdAttachmentPreview
            attachment={applicationData.goverment_id_attachment}
            fileType="ID_PROOF"
            applicantId={applicantId}
            previewGroup={previewGroup}
          />
        )}
        {applicationData.goverment_id_type === "Drivers License" &&
          applicationData.goverment_id_attachment_back?.filepath && (
            <GovernmentIdAttachmentPreview
              attachment={applicationData.goverment_id_attachment_back}
              fileType="ID_PROOF_BACK"
              applicantId={applicantId}
              previewGroup={previewGroup}
            />
          )}
      </div>
    </div>
  );
}
